import { SettingsRowButton } from "Components/Settings/SettingsItem/SettingsRowButton";
import { SettingsRowLink } from "Components/Settings/SettingsItem/SettingsRowLink";
import type { ApplicationLink } from "Types/types";

type Props = {
  link: ApplicationLink;
  isBottomBorderHidden?: boolean;
};

export const SettingsItem = ({ link, isBottomBorderHidden }: Props) => {
  const { url, isDisabled, onClick, isExternalLink, ...restLink } = link;

  if (isDisabled) {
    return <div>{link.text}</div>;
  }

  if (onClick) {
    return (
      <SettingsRowButton
        onClick={onClick}
        isBottomBorderHidden={isBottomBorderHidden}
        {...restLink}
      />
    );
  }

  return (
    <SettingsRowLink
      url={url}
      isExternalLink={isExternalLink}
      isBottomBorderHidden={isBottomBorderHidden}
      {...restLink}
    />
  );
};
